import { Component } from '@theme/component';

/**
 * A custom element that manages a dialog.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} toggler – The dialog element.
 *
 * @extends Component<Refs>
 */
export class TogglerComponent extends Component {
  requiredRefs = ['toggler'];

  
  connectedCallback() {
    super.connectedCallback();
    this.refs.toggler.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.toggler.removeEventListener('click', this.#handleClick);
  }

  /**
   * Closes the dialog when the user clicks outside of it.
   *
   * @param {MouseEvent} event - The mouse event.
   */
  #handleClick(event) {
    event.preventDefault();
    
    
    const dialogInstance = /** @type {import('./dialog').DialogComponent | null} */(document.getElementById('drawer-account-dialog'));

    if (dialogInstance && typeof dialogInstance.toggleDialog === 'function') {
      dialogInstance.toggleDialog();
    } else {
      console.warn('TogglerComponent: Target dialog-component not found.');
    }
  }
}

if (!customElements.get('toggler-component')) customElements.define('toggler-component', TogglerComponent);

